import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './SiteNav.module.css';
import { Button, Logo } from '../ui';
import { TELEGRAM_BOT_URL } from '../../config.js';

const SECTIONS = [
  { href: '#how', label: 'How it works' },
  { href: '#sports', label: 'Sports' },
  { href: '#accuracy', label: 'Track record' },
  { href: '#pricing', label: 'Pricing' },
  { href: '#faq', label: 'FAQ' },
];

/**
 * Sticky marketing header. Section links are in-page anchors; the CTA goes to
 * the app's login.
 *
 * Under 860px the links collapse into a slide-down menu rather than
 * disappearing, so the sections stay reachable on a phone.
 */
export function SiteNav() {
  const [menuOpen, setMenuOpen] = useState(false);

  // Close the menu on Escape — it covers the page, so there must be a way out
  // that isn't hunting for the toggle.
  useEffect(() => {
    if (!menuOpen) return undefined;
    const onKeyDown = (e) => e.key === 'Escape' && setMenuOpen(false);
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [menuOpen]);

  return (
    <header className={styles.nav}>
      <div className={styles.wrap}>
        <Link to="/" className={styles.logo} aria-label="Don Quack home">
          <Logo size={30} />
        </Link>

        <nav className={styles.links} aria-label="Sections">
          {SECTIONS.map((s) => (
            <a key={s.href} href={s.href}>
              {s.label}
            </a>
          ))}
        </nav>

        <div className={styles.cta}>
          <a className={styles.telegram} href={TELEGRAM_BOT_URL}>
            Telegram
          </a>
          <Button to="/app" size="sm">
            Sign up free
          </Button>
          <button
            type="button"
            className={styles.burger}
            aria-expanded={menuOpen}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            onClick={() => setMenuOpen((v) => !v)}
          >
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className={styles.mobileMenu} aria-label="Sections">
          {SECTIONS.map((s) => (
            <a key={s.href} href={s.href} onClick={() => setMenuOpen(false)}>
              {s.label}
            </a>
          ))}
          <a href={TELEGRAM_BOT_URL}>Telegram bot</a>
        </nav>
      )}
    </header>
  );
}
